import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MapaComponent } from "src/app/sections/mapa/mapa.component";
import { AngularCesiumModule } from "angular-cesium";
import { BillboardLayerDevicesComponent } from "../../components/mapa/billboard-layer-devices/billboard-layer-devices.component";
import { HtmlLayerDevicesComponent } from "../../components/mapa/html-layer-devices/html-layer-devices.component";

import { SharedModuleModule } from "../shared-module/shared-module.module";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { MaterialModule } from "../material/material.module";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";

@NgModule({
  declarations: [
    MapaComponent, //TODO: Angular-cesium incompatible
    BillboardLayerDevicesComponent,
    HtmlLayerDevicesComponent,
  ],
  imports: [
    CommonModule,
    SharedModuleModule,
    MaterialModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AngularCesiumModule.forRoot({ fixEntitiesShadows: false, customPipes: [] }), //TODO: Incompatible
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [
    MapaComponent,
    BillboardLayerDevicesComponent,
    HtmlLayerDevicesComponent,
  ],
})
export class MapaModule {}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
